import React from 'react'
import LiveTile from '../common/LiveTile'
type RecommendedLinkProps = {
  name: string
  url: string
  linkText?: string
}
type RecommendedLinkState = null
class RecommendedLink extends React.Component<
  RecommendedLinkProps,
  RecommendedLinkState
> {
  render() {
    const {} = this.props
    return (
      <LiveTile name={this.props.name} to={this.props.url}>
        <p>{this.props.children}</p>
        <p>
          <a
            href={this.props.url}
            className="resource-link"
            target="_blank"
            aria-label={
              this.props.linkText ? this.props.linkText : this.props.name
            }
            rel="noreferrer"
          >
            {this.props.linkText ? this.props.linkText : this.props.name}
          </a>
        </p>
      </LiveTile>
    )
  }
}

export default RecommendedLink
